'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _Context = require('../Core/Context');

var _Context2 = _interopRequireDefault(_Context);

var _CustomFields = require('../CustomFields');

var _ContextObject = require('../Core/ContextObject');

var _ContextObject2 = _interopRequireDefault(_ContextObject);

var _ContextHostUITab = require('./ContextHostUITab');

var _ContextHostUITab2 = _interopRequireDefault(_ContextHostUITab);

var _eventsObject = require('./eventsObject');

var ObjectEvents = _interopRequireWildcard(_eventsObject);

var _properties = require('./properties');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @ignore
 *
 * @param {AppEventEmitter} outgoingDispatcher the outgoing events dispatcher
 * @param {AppEventEmitter} incomingDispatcher the incoming events dispatcher
 * @param {InstanceProps} instanceProps the instance properties bag
 * @param {ContextProps} contextProps the context properties bag
 *
 * @return {CustomFieldsClient|null}
 */
function createCustomFieldClient(_ref) {
  var outgoingDispatcher = _ref.outgoingDispatcher,
      incomingDispatcher = _ref.incomingDispatcher,
      instanceProps = _ref.instanceProps,
      contextProps = _ref.contextProps;

  var endpoint = null;
  switch (contextProps.contextType) {
    case 'person':
      endpoint = 'people/' + contextProps.entityId;
      break;
    case 'organization':
      endpoint = 'organizations/' + contextProps.entityId;
      break;
    case 'ticket':
      endpoint = 'tickets/' + contextProps.entityId;
      break;
  }

  if (endpoint) {
    return new _CustomFields.CustomFieldsClient({
      outgoingDispatcher: outgoingDispatcher,
      instanceId: instanceProps.instanceId,
      endpoint: endpoint
    });
  }

  return null;
}

/**
 * A factory for application contexts
 *
 * @class
 */

var ContextFactory = function () {
  function ContextFactory() {
    (0, _classCallCheck3.default)(this, ContextFactory);
  }

  (0, _createClass3.default)(ContextFactory, null, [{
    key: 'create',


    /**
     * Creates the application context
     *
     * @method
     *
     * @param {AppEventEmitter} outgoingDispatcher the outgoing events dispatcher
     * @param {AppEventEmitter} incomingDispatcher the incoming events dispatcher
     * @param {InstanceProps} instanceProps the instance properties bag
     * @param {ContextProps} contextProps the context properties bag
     * @return {Context}
     */
    value: function create(outgoingDispatcher, incomingDispatcher, instanceProps, contextProps) {
      var customFields = createCustomFieldClient({ outgoingDispatcher: outgoingDispatcher, incomingDispatcher: incomingDispatcher, instanceProps: instanceProps, contextProps: contextProps });

      var object = new _ContextObject2.default({
        propertyProvider: (0, _properties.propertyProviderTab)(outgoingDispatcher, contextProps),
        type: contextProps.contextType,
        entityId: contextProps.entityId,
        customFields: customFields
      });
      var hostUI = new _ContextHostUITab2.default((0, _extends3.default)({ outgoingDispatcher: outgoingDispatcher }, contextProps.toJS()));

      var props = (0, _extends3.default)({ outgoingDispatcher: outgoingDispatcher, hostUI: hostUI, object: object }, contextProps.toJS(), instanceProps.toJS());
      return new _Context2.default(props);
    }
  }, {
    key: 'contextObjectTypes',

    /**
     * Returns a list of all the Deskpro Object context type names it can create
     *
     * @method
     * @returns {Array.<string>}
     */
    get: function get() {
      return ['ticket', 'person', 'organization'];
    }
  }]);
  return ContextFactory;
}();

exports.default = ContextFactory;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Context/ContextFactory.js
// module id = 319
// module chunks = 0